import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "d-header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "d-slot"
}
const _hoisted_4 = { key: 0 }

import { computed, useSlots } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'Cards',
  props: {
    isLoaded: { type: Boolean },
    title: {},
    icon: {},
    cta: {},
    link: {},
    linkText: {},
    description: {},
    slotTitle: {}
  },
  setup(__props: any) {

const slots = useSlots();
const props = __props;

const setLoading = computed(() => { return !props.isLoaded ? 'loading' : ''; }); // eslint-disable-line @typescript-eslint/no-unused-vars

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!props.isLoaded)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(props.setLoading)
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("i", { class: "icon-spinner animate-spin" }, null, -1)
      ]), 2))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["d-main", props.setLoading])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("i", {
            class: _normalizeClass(["props.icon icon-fw", props.icon])
          }, null, 2),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createVNode(_component_router_link, {
            to: props.link
          }, {
            default: _withCtx(() => [
              _createElementVNode("h1", null, _toDisplayString(props.title), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _cache[3] || (_cache[3] = _createTextVNode()),
        _createElementVNode("p", null, _toDisplayString(props.description), 1),
        _cache[4] || (_cache[4] = _createTextVNode()),
        _createVNode(_component_router_link, {
          class: "btn role-secondary",
          to: props.cta
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.linkText), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _cache[5] || (_cache[5] = _createTextVNode()),
        (_unref(slots).default)
          ? (_openBlock(), _createElementBlock("hr", _hoisted_2))
          : _createCommentVNode("", true),
        _cache[6] || (_cache[6] = _createTextVNode()),
        (_unref(slots).default)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (props.slotTitle)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(props.slotTitle), 1))
                : _createCommentVNode("", true),
              _cache[2] || (_cache[2] = _createTextVNode()),
              _renderSlot(_ctx.$slots, "default")
            ]))
          : _createCommentVNode("", true)
      ], 2))
}
}

})